<script setup>
import counts from './_counts.vue'

// Shared row content for the v2 tag pickers: color dot, name, badge, description and counts
const props = defineProps({
    tag: {
        type: Object,
        required: true,
    },
    emphasized: {
        type: Boolean,
        required: false,
        default: false,
    },
    displayCounts: {
        type: Array,
        required: false,
        default: () => [],
    },
})
</script>

<template>
    <span
        class="w-2.5 h-2.5 rounded-full shrink-0"
        :class="tag.color ? '' : 'bg-gray-300'"
        :style="tag.color ? {backgroundColor: tag.color} : {}"
    ></span>

    <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2">
            <span
                class="text-sm text-gray-900 truncate"
                :class="emphasized ? 'font-medium' : ''"
            >
                {{ tag.name }}
            </span>
            <span
                v-if="tag.is_system_tag"
                class="shrink-0 px-1.5 py-px text-xxs text-gray-500 bg-gray-100 rounded"
            >
                {{ _mft('crm:tag.systemTag') }}
            </span>
        </div>
        <div
            v-if="tag.description"
            class="text-xs text-gray-500 truncate"
        >
            {{ tag.description }}
        </div>
    </div>

    <counts
        v-if="displayCounts.length > 0"
        :tag="tag"
        :display-counts="displayCounts"
        class="text-gray-500 shrink-0"
    />
</template>
